import React, { useEffect, useState } from 'react'
import DataTableComponent from '../../common/data-table-component/data-table-component';
import { useSearch } from 'rsuite/esm/internals/Picker';
import axios from '../../../api/axios';
import { Button, Input, TextField, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Typography, CircularProgress } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';


export default function UserEmailCreateComponent() {

const [rowData, setRowData] = useState([]);
const [isLoading, setIsLoading] = useState(true);
const [emailCreateData,setEmailCreateData] = useState([]);


useEffect(()=>{
  loadNewEmails();
  
},[]);

const loadNewEmails = () => {
  setIsLoading(true);
  axios.get("/create-new-email-details")
      .then(async function (response) {
        if(response.status === 200){
            
            var data =response.data.map((val)=>({
                ...val,
                newSjpEmailAddress: '', 
            }));
            setEmailCreateData(data)
            setIsLoading(false);
        }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });
}

const handleChangeEmail = (e, indexNo) => {

    const data = emailCreateData.map((val, index) => {
        // Check if the current index matches the index we're updating
        if (index === indexNo) {
            return {
                ...val,
                newSjpEmailAddress: e.target.value, // Update the email address
            };
        }
        // Return the existing value for other indices
        return val;
    });

    // Update the state with the new data
    setEmailCreateData(data);
    
};

const handleSubmitCreateEmail = (indexNo) =>{
  
  const submittedDataArray = emailCreateData.map((val, index) => {
        if (index === indexNo) {
            return {
                sjp_email: val?.newSjpEmailAddress,
                empNo: val?.personal_details[0].employee_no
            };
        }
        return null;
    }).filter(item => item !== null);

const subbmittedDataObject = submittedDataArray.reduce((acc, item) => {
    acc["sjp_email"] = item.sjp_email;
    acc["empNo"] = item.empNo; // Use empNo as the key
    return acc;
}, {});
console.log(subbmittedDataObject)
  setIsLoading(true);
  axios.post("/admin/user-update/email",subbmittedDataObject)
      .then(async function (response) {
        console.log(response.data);
        // if(response.status === 200){
        //   if(response?.data?.status === 'success'){
        //       alert("updated");
        //   }else{
        //     alert("not updated");
        //   }
            
        //     setIsLoading(false);
        // }
      })
      .catch(function (error) {
      
        setTimeout(() => {
          console.log(error);
        }, 2000);
      });

}


const [confirmOpen, setConfirmOpen] = useState(false);
const [confirmIndex, setConfirmIndex] = useState(null);
const [confirmLoading, setConfirmLoading] = useState(false);

const handleSubmitDeleteEmailRequest = (indexNo) =>{
  setConfirmIndex(indexNo);
  setConfirmOpen(true);
}

const handleConfirmDelete = async () => {
  if (confirmIndex == null) return;
  const submittedDataArray = emailCreateData.map((val, index) => {
    if (index === confirmIndex) {
      return { empNo: val?.personal_details[0].employee_no };
    }
    return null;
  }).filter(item => item !== null);


  setConfirmLoading(true);
  try {
    const response = await axios.post('/delete-email-request', { empNo: submittedDataArray[0].empNo });
    console.log(response.data);
    if (response?.data?.status === 'success') {
      alert('Deleted successfully');
      loadNewEmails();
    } else {
      alert('Not deleted');
    }
  } catch (err) {
    console.log(err);
    alert('Request failed');
  } finally {
    setConfirmLoading(false);
    setConfirmOpen(false);
    setConfirmIndex(null);
  }
}

const handleCancelConfirm = () => {
  setConfirmOpen(false);
  setConfirmIndex(null);
}

  const formatString = (str) => {
    const safe = str == null ? '' : String(str);
    return safe.split('\n').map((line, index) => (
      <span key={index}>
        {line}
        <br />
      </span>
    ));
  };

  const formatDateOnly = (dt) => {
    if (dt == null) return '';
    const s = String(dt);
    if (s.includes('T')) return s.split('T')[0];
    if (s.includes(' ')) return s.split(' ')[0];
    const d = new Date(s);
    if (!isNaN(d)) return d.toISOString().split('T')[0];
    return s;
  };

  const renderCopyableField = (str) => {
    const text = str == null ? '' : String(str);

    const CopyableField = ({ text }) => {
      const [copied, setCopied] = useState(false);
      const handleCopy = () => {
        if (navigator?.clipboard?.writeText) {
          navigator.clipboard.writeText(text).catch(() => {});
        } else {
          const el = document.createElement('textarea');
          el.value = text;
          document.body.appendChild(el);
          el.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(el);
        }
        
        setCopied(true);
        setTimeout(() => setCopied(false), 1400);
      };

      return (
        <div style={{ position: 'relative', paddingTop: 22 }}>
          <div style={{ position: 'absolute', top: 0, right: 0 }}>
            <Tooltip title={copied ? 'Copied' : 'Copy'}>
              <IconButton
                size="small"
                onClick={handleCopy}
                aria-label="copy"
                sx={{
                  bgcolor: copied ? 'rgba(76,175,80,0.08)' : 'rgba(0,0,0,0.04)',
                  color: copied ? 'success.main' : 'inherit',
                  '&:hover': { bgcolor: copied ? 'rgba(76,175,80,0.12)' : 'rgba(0,0,0,0.08)' },
                  width: 26,
                  height: 26,
                  minWidth: 26,
                  minHeight: 26,
                  boxShadow: 'none',
                  '& .MuiSvgIcon-root': { fontSize: 16 }
                }}
              >
                {copied ? <CheckIcon fontSize="small" /> : <ContentCopyIcon fontSize="small" />}
              </IconButton>
            </Tooltip>
          </div>
          {formatString(text)}
        </div>
      );
    };

    return <CopyableField text={text} />;
  };


const columns = [
  { id: 'id', label: 'ID', width: 10 },
  { id: 'requestDate', label: 'Requested Date', width: 140 },
  { id: 'details', label: 'Details', minWidth: 200 },
  { id: 'preferredUserName', label: 'Preferred User Name', width: 100 },
  { id: 'extraDetails', label: 'Extra Details', maxWidth: 100 },
  { id: 'sjpEmail', label: 'SJP Mail', minWidth:270 },
  { id: 'action', label: 'Action', width: 170 },
  ];

  useEffect(()=>{
    var res =emailCreateData.map((val,index)=>({
        id : index+1,
        requestDate: formatDateOnly(val?.request_date),
        details: renderCopyableField(
          val?.personal_details[0]?.employee_no+"\n"+
          val?.extra_details?.designation_name+"\n"+
          val?.personal_details[0]?.employee_work_type+"\n"+
          "Terminate Date: "+val?.personal_details[0]?.salary_termination_date_1+"\n"+
          val?.personal_details[0]?.department_name+"\n"+
          val?.personal_details[0]?.faculty_name
        ),
        preferredUserName: renderCopyableField(
          "Name 01 - "+val?.preferred_user_name?.preferred_user_name_1+"\n"+
          "Name 02 - "+val?.preferred_user_name?.preferred_user_name_2
        ),
        extraDetails: renderCopyableField(
          val?.extra_details?.name_denoted_by_initials+"\n"+
          val?.extra_details?.title_name+" "+val?.extra_details?.initials+" "+val?.extra_details?.last_name+"\n"+
          val?.extra_details?.alternate_email_address+"\n"+
          val?.extra_details?.mobile_no+"\n"+
          val?.extra_details?.current_sjp_mail
        ),
        sjpEmail:<><TextField
              label="Email"
              variant="outlined" // This makes the input outlined
               value={val?.newSjpEmailAddress}
               onChange={(val)=>handleChangeEmail(val,index)}
              fullWidth // Optional: to make the input take full width
            /></>,
        action:<>
         <div style={{ display: "flex", gap: "10px" }}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => handleSubmitCreateEmail(index)}
                  >
                    Update
                  </Button>

                  <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => handleSubmitDeleteEmailRequest(index)}
                  >
                    Delete
                  </Button>
                </div>
        </>
    }));
    setRowData(res);

  },[emailCreateData])

  // const data = [{ id: 1, requestDate: '2024-05-10', empNo: '300032', name: 'Mr.. W.M.D. Priyankara', faculty: 'Faculty of Technology', action:"action" },{ id: 2, firstName: 'John', lastName: 'Doe' }];

   const renderRowExpanded = rowData => {
    return (
     <div>
        <div className='row'>
            <div className='col-sm-4'>
                <h5>Details</h5><br/>
                300032
                Lecturer
                Civil and Environmental Technology
                Terminate Date - 2025-02-14
                Faculty of Technology
            </div>
            <div className='col-sm-8'>
                

            </div>

        </div>
      </div>
    );
  };

  const selectedItem = (confirmIndex != null && emailCreateData[confirmIndex]) ? emailCreateData[confirmIndex] : null;
  const selectedName = selectedItem ? (selectedItem?.extra_details?.title_name + ' ' + selectedItem?.extra_details?.initials + ' ' + selectedItem?.extra_details?.last_name).trim() : '';
  const selectedEmpNo = selectedItem ? selectedItem?.personal_details?.[0]?.employee_no : '';

  return (
     <div class="product__discount">
        <div class="section-title product__discount__title">
            <h2>Create Email Accounts</h2>
            <div style={{ padding:20 }}></div>
            <DataTableComponent columns={columns} data={rowData} />
            <Dialog
              open={confirmOpen}
              onClose={handleCancelConfirm}
              fullWidth
              maxWidth="xs"
            >
              <DialogTitle>Confirm action</DialogTitle>
              <DialogContent>
                <Typography sx={{ mb: 2 }}>Are you sure you want to delete this email request?</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
                  <strong>Name:</strong> {selectedName || '—'}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                  <strong>Emp No:</strong> {selectedEmpNo || '—'}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    p: 1.5,
                    bgcolor: '#fff3cd',
                    border: '1px solid #ffc107',
                    borderRadius: 1,
                    color: '#856404'
                  }}
                >
                  <strong>⚠ Warning:</strong> This action cannot be undone. Once deleted, this email request and all associated data will be permanently removed from the system.
                </Typography>
              </DialogContent>
              <DialogActions sx={{ px: 2, pb: 2 }}>
                <Button onClick={handleCancelConfirm} color="inherit">Cancel</Button>
                <Button
                  onClick={handleConfirmDelete}
                  color="error"
                  variant="contained"
                  disabled={confirmLoading}
                  startIcon={confirmLoading ? <CircularProgress size={14} /> : null}
                >
                  Delete
                </Button>
              </DialogActions>
            </Dialog>
        </div>               
    </div>
  )
}
